import React from "react";
import { buildSVGText } from "../svg-helpers";

export default React.memo((props) => {
  return buildSVGText("#", { ok: true, ...props });
});
